import { CircularProgress } from '@material-ui/core';
import { BetActionErrorResponseDataDto } from 'api/common.generated';
import cn from 'classnames';
import { usePromoConditionsState } from 'features/PromoConditions';
import isEmpty from 'lodash/isEmpty';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BalanceState, BETSType, CouponState, PlaceBet } from 'shared/interface';
import TopUpAccount from '../../../topUpAccount';
import AKOBet from '../ako';
import BetslipEmpty from '../BetslipEmpty';
import { CouponPanel } from '../CouponPanel/CouponPanel';
import CouponRemoveAllButton from '../CouponRemoveAllButton';
import CouponTabs from '../CouponTabs';
import CouponUndoButton from '../CouponUndoButton';
import SystemBet from '../SystemBet';
import './styles.scss';

interface Props {
	isAkoBetTab: boolean;
	isBetslipEmpty: boolean;
	isCal: boolean;
	betStatics: any;
	stackValue: number;
	errorCode: number[];
	loading: boolean;
	freeBets: any[];
	selectedFreeBet: string;
	betLoading: boolean;
	betType: number;
	approvedSlip: boolean;
	betActionErrors: BetActionErrorResponseDataDto[];
	warnings: string[];
	completedEvents: string[];
	selectedBalanceType: string;
	outcomes: PlaceBet[];
	betMode: string;
	isSystemBetTab: boolean;
	blocks: PlaceBet[][];
	selectedCombination: string;
	awaitingWinningResp: boolean;
	isRestoringBets: boolean;
	balanceData: BalanceState;
	bets: BETSType;
	temporaryBets: any;
	coupon: CouponState;
	onChangeStackValue: (value: number) => void;
	handelSelectedBet: (isSelected: boolean, outcomeId: string) => void;
	handleOddsChangeOption: (value: string) => void;
	onClickPlaceBet: () => void;
	changeNavigationView: () => void;
	onCloseError: (error: number, indexOfErrorDetail: number) => void;
	handleIsRestoringBets: (isRestoring: boolean) => void;
	handleSelectedCombination: (value: string) => void;
	handleIsCal: (value: boolean) => void;
	removeBet: (outcomeId: string) => void;
	handleGroupChange: (outcomeId: string, newGroupIndex?: number | undefined) => void;
	deselectFreeBet: () => void;
	handelSelectedFreeBet: (id: string, stack: number) => void;
	removeAllBets: (coupon: any) => void;
	deleteTemporaryBets: () => void;
	onChangeGameMode: (mode: string) => void;
	setStakeMethod: (stake: string) => void;
}

const DesktopCouponBasket: FC<Props> = ({
	isAkoBetTab,
	isBetslipEmpty,
	isCal,
	betActionErrors,
	betLoading,
	betStatics,
	betType,
	freeBets,
	selectedBalanceType,
	selectedFreeBet,
	stackValue,
	outcomes,
	loading,
	errorCode,
	betMode,
	approvedSlip,
	warnings,
	completedEvents,
	isSystemBetTab,
	blocks,
	selectedCombination,
	awaitingWinningResp,
	isRestoringBets,
	balanceData,
	bets,
	temporaryBets,
	handelSelectedBet,
	removeBet,
	onCloseError,
	handleSelectedCombination,
	onChangeStackValue,
	onClickPlaceBet,
	handleIsCal,
	handleIsRestoringBets,
	handleOddsChangeOption,
	handleGroupChange,
	deselectFreeBet,
	handelSelectedFreeBet,
	changeNavigationView,
	removeAllBets,
	deleteTemporaryBets,
	onChangeGameMode,
	setStakeMethod,
}) => {
	const { t } = useTranslation();

	const promoConditionsState = usePromoConditionsState();
	const [isFastPaymentReady, setIsFastPaymentReady] = useState(false);

	const getCouponPanelHeight = () => {
		if (isFastPaymentReady) {
			return isBetslipEmpty ? 'h-[calc(100%-135px)]' : 'h-[calc(100%-195px)]';
		} else {
			return isBetslipEmpty ? 'h-[calc(100%-60px)]' : 'h-[calc(100%-120px)]';
		}
	};

	return (
		<div className={`relative h-[calc(100vh-100px)] ${isFastPaymentReady ? '' : ''}`}>
			<TopUpAccount location={'web-coupon'} onReady={() => setIsFastPaymentReady(true)} className="overflow-hidden rounded-8 p-2 mb-4" />
			<div className="coupon__title flex justify-between">
				<h2 className="position--relative no--margin text--white font-size--20" data-count="5">
					{t('coupon')}
				</h2>
				{isBetslipEmpty && !isEmpty(temporaryBets) && isRestoringBets && (
					<CouponUndoButton
						isRestoringBets={isRestoringBets}
						handleIsRestoringBets={handleIsRestoringBets}
						deleteTemporaryBets={deleteTemporaryBets}
						temporaryBets={temporaryBets}
						bets={bets}
						balanceData={balanceData}
						isBetslipEmpty={isBetslipEmpty}
						className={'!text-gray-100'}
					/>
				)}
			</div>
			{!isBetslipEmpty && (
				<div className="DesktopCouponBasket__tabs">
					<CouponTabs isBetslipEmpty={isBetslipEmpty} bets={bets} balanceData={balanceData} onChangeGameMode={onChangeGameMode} />
					{!isBetslipEmpty && <CouponRemoveAllButton removeAllBets={removeAllBets} />}
				</div>
			)}
			<div className={cn('DesktopCouponBasket__coupons relative flex flex-col justify-start', getCouponPanelHeight())}>
				{approvedSlip && <CircularProgress color="primary" className="approved-slips-loader" />}
				{isBetslipEmpty && <BetslipEmpty promoConditionsState={promoConditionsState} />}
				{isAkoBetTab && !isBetslipEmpty && (
					<AKOBet
						promoConditionsState={promoConditionsState}
						setStakeMethod={setStakeMethod}
						isCal={isCal}
						handleIsCal={handleIsCal}
						allBets={outcomes}
						removeBet={removeBet}
						betStatics={betStatics}
						onChangeStackValue={onChangeStackValue}
						stackValue={stackValue}
						handelSelectedBet={handelSelectedBet}
						handleOddsChangeOption={handleOddsChangeOption}
						onClickPlaceBet={onClickPlaceBet}
						changeNavigationView={changeNavigationView}
						errorCode={errorCode}
						loading={loading}
						freeBets={freeBets}
						selectedFreeBet={selectedFreeBet}
						onCloseError={onCloseError}
						betLoading={betLoading}
						betType={betMode}
						approvedSlip={approvedSlip}
						betActionErrors={betActionErrors}
						warnings={warnings}
						completedEvents={completedEvents}
						selectedBalanceType={selectedBalanceType}
						handleIsRestoringBets={handleIsRestoringBets}
						bets={bets}
					/>
				)}

				{isSystemBetTab && (
					<SystemBet
						setStakeMethod={setStakeMethod}
						isCal={isCal}
						handleIsCal={handleIsCal}
						outcomes={outcomes}
						blocks={blocks}
						removeBet={removeBet}
						betStatics={betStatics}
						onChangeStackValue={onChangeStackValue}
						handelSelectedBet={handelSelectedBet}
						stackValue={stackValue}
						handleOddsChangeOption={handleOddsChangeOption}
						selectedCombination={selectedCombination}
						handleSelectedCombination={handleSelectedCombination}
						onClickPlaceBet={onClickPlaceBet}
						changeNavigationView={changeNavigationView}
						errorCode={errorCode}
						loading={loading}
						onCloseError={onCloseError}
						betLoading={betLoading || awaitingWinningResp}
						betType={betMode}
						approvedSlip={approvedSlip}
						betActionErrors={betActionErrors}
						warnings={warnings}
						completedEvents={completedEvents}
						handleGroupChange={handleGroupChange}
						isDesktop={false}
						handleIsRestoringBets={handleIsRestoringBets}
						bets={bets}
					/>
				)}
				<CouponPanel
					promoConditionsState={promoConditionsState}
					isCal={isCal}
					handleIsCal={handleIsCal}
					deselectFreeBet={deselectFreeBet}
					isBetslipEmpty={isBetslipEmpty}
					changeNavigationView={changeNavigationView}
					betStatics={betStatics}
					onClickPlaceBet={onClickPlaceBet}
					outcomes={outcomes}
					handleOddsChangeOption={handleOddsChangeOption}
					loading={loading}
					selectedCombination={selectedCombination}
					onChangeStackValue={onChangeStackValue}
					betLoading={betLoading}
					approvedSlip={approvedSlip}
					betMode={betMode}
					selectedBalanceType={selectedBalanceType}
					betType={betType}
					freeBets={freeBets}
					price={stackValue}
					blocks={blocks}
					awaitingWinningResp={awaitingWinningResp}
					selectedFreeBet={selectedFreeBet}
					handelSelectedFreeBet={handelSelectedFreeBet}
				/>
			</div>
		</div>
	);
};

export default DesktopCouponBasket;
